<template>
  <div class="sidebar">
    <div class="logo" v-if="!collapse" @click="backhome">
      <img src="../assets/img/logo.png" alt="" />
      <span>{{ i18n.breadcrumb }}</span>
    </div>
    <el-menu v-if="isrouterview"
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router
    >
      <template v-for="item in i18n.items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template #title>
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu
                v-if="subItem.subs"
                :index="subItem.index"
                :key="subItem.index"
              >
                <template #title>{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                  >{{ threeItem.title }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item
                v-else
                :index="subItem.index"
                :key="subItem.index"
                >{{ subItem.title }}</el-menu-item
              >
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <template #title>{{ item.title }}</template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
// import bus from "../common/bus";
export default {
  data() {
    return {
      i18n: [],
      isrouterview:true,
      items: [
        {
          icon: "el-icon-lx-home",
          index: "homepage",
          title: "首页"
        },
        {
          icon: "el-icon-lx-copy",
          index: "table2",
          title: "新闻资讯"
        },
        {
          icon: "el-icon-lx-copy",
          index: "InternetofThings",
          title: "物联网产品中心"
        },
        {
          icon: "el-icon-lx-copy",
          index: "rygl",
          title: "解决方案",
          subs: [
            {
              index: "userManagement",
              title: "智慧校园",
            },
            {
              index: "voucher",
              title: "智慧医院",
            }
          ],
        },
        {
          icon: "el-icon-lx-copy",
          index: "tabs",
          title: "成功案例"
        },
        {
          icon:"el-icon-lx-rank",
          index:"table2",
          title:"服务与支持"
        },
        {
          icon: "el-icon-lx-rank",
          index: "7",
          title: "加入志为"
        },
        {
          icon: "el-icon-lx-rank",
          index: "permission",
          title: "系统管理",
        },
      ],
    };
  },
  created() {
    var lan = this.$store.state.lange;
    if (!lan) {
      this.i18n = this.$language.cn.i18n;
    } else {
      this.i18n = this.$language.cn.i18n;
    }
  },
  methods: {
    reload() {
      this.isrouterview = false;
      this.$nextTick(function () {
        this.isrouterview = true;
      });    },
    backhome() {},
  },
  computed: {
    contractFile() {
      return this.$store.state.user.contractFile;
    },
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    // contractFile: {
    //   lange: true,
    //   handler: function (newval) {
    //     this.operations(newval);
    //   },
    // },
  },
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
  /* overflow-y: scroll; */
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}
.sidebar > ul {
  height: 100%;
}
.el-submenu .el-menu-item {
  padding-left: 60px !important;
}
.logo {
  background: rgb(50, 65, 87);
  text-align: center;
  color: #fff;
  overflow: hidden;
  width: 250px;
  cursor: pointer;
}
.logo span {
  font-size: 20px;
  line-height: 60px;
}
.logo img {
  width: 90%;
  display: block;
  box-sizing: border-box;
  margin: 10px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue